var a={base:{}};export{a as default};
//# sourceMappingURL=defaultStyles.js.map
